import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<g id=\"plus_Icons/Plus\">\n<path id=\"plus_Union\" clip-rule=\"evenodd\" d=\"M9 1H7V7H1V9H7V15H9V9H15V7H9V1Z\" fill=\"#7F7F7F\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol